import ApiResponse from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponse";
import GenericCrudService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudService";
import HttpClient from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClient";
import Holiday from "../models/Holiday";

class HolidayService extends GenericCrudService<Holiday> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findHolidaysByCountry(page: number, pageSize: number, country: string): Promise<ApiResponse<Holiday>> {
    let url = `${this.basePath}/countries?page=${page}&pageSize=${pageSize}`;
    url += country ? "&country=" + country : "";
    return HttpClient.get(url, true);
  }

  findHolidaysOfMonthByCountry(month: number, country: String): Promise<ApiResponse<Holiday[]>> {
    return HttpClient.get(`${this.basePath}/month/${month}?country=${country}`, true);
  }
}

export default new HolidayService("/ensolvers-ops/holiday");
